module.exports = __webpack_public_path__ + "img/rockestate-logo-square-dark.4408ab3a.svg";